/*
 * SystemOverviewContent - System 概览页面内容
 * 整合环境配置、部署状态、组件列表等信息
 */

import React from 'react';
import { Grid } from '@material-ui/core';
import {
  EntityLinksCard,
  EntitySwitch,
  EntityOrphanWarning,
  EntityProcessingErrorsPanel,
  isOrphan,
  hasCatalogProcessingErrors,
  hasRelationWarnings,
  EntityRelationWarning,
} from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import { SystemAboutCard } from './SystemAboutCard';
// import { SystemDeploymentsSummary } from './SystemDeploymentsSummary'; // 已移至 Components tab

/**
 * System 实体的警告内容
 */
export const systemWarningContent = (
  <>
    <EntitySwitch>
      <EntitySwitch.Case if={isOrphan}>
        <Grid item xs={12}>
          <EntityOrphanWarning />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case if={hasRelationWarnings}>
        <Grid item xs={12}>
          <EntityRelationWarning />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case if={hasCatalogProcessingErrors}>
        <Grid item xs={12}>
          <EntityProcessingErrorsPanel />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>
  </>
);

/**
 * System 概览页面内容
 */
export const SystemOverviewContent: React.FC = () => {
  return (
    <Grid container spacing={3} alignItems="stretch">
      {systemWarningContent}

      {/* 第一行：System 信息（合并 About 和环境配置） */}
      <Grid item xs={12}>
        <SystemAboutCard />
      </Grid>

      {/* 第二行：部署状态概览 - 已移至 Components tab，避免重复 */}
      {/* <Grid item xs={12}>
        <SystemDeploymentsSummary />
      </Grid> */}

      {/* 第三行：关系图 */}
      <Grid item xs={12}>
        <EntityCatalogGraphCard variant="gridItem" height={400} />
      </Grid>

      {/* 第四行：链接 */}
      <Grid item md={4} xs={12}>
        <EntityLinksCard />
      </Grid>
    </Grid>
  );
};

export default SystemOverviewContent;

